import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIntersectionObserver from 'UIComponents/observer/UIIntersectionObserver';
import ValidI18nMessage from 'ecosystem-marketplace-core/i18n/components/ValidI18nMessage';
import { validUnescapedText } from 'ecosystem-marketplace-core/i18n/utils';
import CollectionRouter from './CollectionRouter';
import ThemeResultsSectionDataContainer from '../../../components/storefront/results/ThemeResultsSectionDataContainer';
import { toSearchQuery } from '../../../utils/themeQuery';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
import { fetchCollectionOfferingIdsFromSelfServe } from '../../../clients/ecosystemClient';
import ThemeQuery from '../../../records/ThemeQuery';
const MAX_HOME_COLLECTION_COUNT = 3;

const getSearchQueryFromSelfServe = collection => {
  return fetchCollectionOfferingIdsFromSelfServe(collection.id).then(offeringIds => {
    const themeQuery = new ThemeQuery({
      [ThemeQueryField.OFFERING_IDS]: offeringIds,
      [ThemeQueryField.LIMIT]: MAX_HOME_COLLECTION_COUNT
    });
    return toSearchQuery(themeQuery);
  });
};

const CollectionSection = ({
  className,
  collection,
  collectionType,
  linkTo,
  trackInteraction,
  trackPageview
}) => {
  const section = useMemo(() => {
    return `collection::${collection.id}::${collectionType}`;
  }, [collection.id, collectionType]);
  const trackCollectionInteraction = useCallback((action, properties = {}) => {
    trackInteraction(action, Object.assign({}, properties, {
      section,
      type: 'theme'
    }));
  }, [trackInteraction, section]);
  const trackCollectionPageview = useCallback((properties = {}) => {
    trackPageview(Object.assign({}, properties, {
      section,
      type: 'theme'
    }));
  }, [trackPageview, section]);
  const searchQuery = getSearchQueryFromSelfServe(collection);
  return /*#__PURE__*/_jsx(UIIntersectionObserver, {
    onIntersectionChange: ({
      entries,
      observer
    }) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
      }
    },
    renderContent: isIntersecting => {
      if (isIntersecting) {
        return /*#__PURE__*/_jsx(ThemeResultsSectionDataContainer, {
          className: className,
          maxColumns: MAX_HOME_COLLECTION_COUNT,
          subtitle: /*#__PURE__*/_jsx(ValidI18nMessage, {
            defaultValue: collection.publishedListing.tagline,
            message: `marketplace-assets-ui.collections.collection_${collection.id}.tagline`
          }),
          title: /*#__PURE__*/_jsx(ValidI18nMessage, {
            defaultValue: collection.publishedListing.title,
            message: `marketplace-assets-ui.collections.collection_${collection.id}.title`
          }),
          titleControls: /*#__PURE__*/_jsx(CollectionRouter, {
            linkTo: linkTo,
            linkText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.home.exploreCollection",
              options: {
                title: validUnescapedText(`marketplace-assets-ui.collections.collection_${collection.id}.title`, {}, collection.publishedListing.title)
              }
            }),
            trackInteraction: trackInteraction
          }),
          trackInteraction: trackCollectionInteraction,
          trackPageview: trackCollectionPageview,
          searchQuery: searchQuery
        });
      }

      return /*#__PURE__*/_jsx("div", {});
    }
  });
};

export default CollectionSection;